import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import store from "@/store";

// CONFIG FIREBASE
const firebaseConfig = {
  apiKey: "AIzaSyAY77IWkL15w1jeM6iuVoo94OK5q6zisMU",
  authDomain: "app-desenvolvimento-pessoal.firebaseapp.com",
  projectId: "app-desenvolvimento-pessoal",
  storageBucket: "app-desenvolvimento-pessoal.appspot.com",
  messagingSenderId: "824308395590",
  appId: "1:824308395590:web:cb93aac57517f0d92d2447",
  measurementId: "G-D5WL1LPX7V",
};

// INITIALIZE FIREBASE
initializeApp(firebaseConfig);

//State changed user firebase
const auth = getAuth();
onAuthStateChanged(auth, (user) => {
  store.dispatch("stateChangedUserFirebase", user);
});
